export default "__VITE_ASSET__dy$lCbnP__"